import React, { useContext } from 'react';
import { FiveHundredErrorPage, StaticContext } from '@sm/webassets';
import { t, T } from '@sm/intl';

import getQueryParam from '~app/helpers/queryParams';
import { QueryParams } from '~common/entities/smParams';
import { SamlErrorCode } from '~common/errors/userFacing';
import COPY, { getErrorMessage } from './copy';

export function getSamlErrorCode(errorReason: string | undefined): SamlErrorCode | undefined {
  if (errorReason && Object.values<string>(SamlErrorCode).includes(errorReason)) {
    return errorReason as SamlErrorCode;
  }

  return undefined;
}

export default function ErrorPage(): JSX.Element {
  const {
    environment: { languageCode },
    pageRequestId,
  } = useContext(StaticContext);
  const errorReason = getQueryParam<string>(QueryParams.ERROR);
  const samlErrorCode = getSamlErrorCode(errorReason);

  if (samlErrorCode) {
    const { desc, values } = getErrorMessage(languageCode, samlErrorCode);

    return (
      <FiveHundredErrorPage
        requestId={`${t(COPY.ERROR_CODE)}: ${pageRequestId}`}
        openingMessage={t(COPY.ERROR_TITLE)}
        errorTitle="" // this is to override the default title
        errorMessage={<T desc={desc} html values={values} />}
      />
    );
  }

  return <FiveHundredErrorPage requestId={pageRequestId} />;
}
